import { getAddress } from "viem"

export const vaults = new Map([
  [
    getAddress("0x859160DB5841E5cfB8D3f144C6b3381A85A4b410"),
    {
      name: "Euler Base WETH",
      description:
        "A conservative WETH vault collateralized by other vaults in the Euler Base cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x7b181d6509DEabfbd1A23aF1E65fD46E89572609"),
    {
      name: "Euler Base wstETH",
      description:
        "A conservative wstETH vault collateralized by other vaults in the Euler Base cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x358f25F82644eaBb441d0df4AF8746614fb9ea49"),
    {
      name: "Euler Base cbETH",
      description:
        "A conservative cbETH vault collateralized by other vaults in the Euler Base cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xd4A805261B28f375fc9c3d89EcD2C952Cd130d14"),
    {
      name: "Euler Base weETH",
      description:
        "A conservative weETH vault collateralized by other vaults in the Euler Base cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xa487f940D6f40D7304CD4e62751220f97124BeC9"),
    {
      name: "Euler Base ezETH",
      description:
        "A conservative ezETH vault collateralized by other vaults in the Euler Base cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x8b70a855B057cA85F38Ebb2a7399D9FE0BDC1046"),
    {
      name: "Euler Base RETH",
      description:
        "A conservative RETH vault collateralized by other vaults in the Euler Base cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x0A1a3b5f2041F33522C4efc754a7D096f880eE16"),
    {
      name: "Euler Base USDC",
      description:
        "A conservative USDC vault collateralized by other vaults in the Euler Base cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x9ECD9fbbdA32b81dee51AdAed28c5C5039c87117"),
    {
      name: "Euler Base EURC",
      description:
        "A conservative EURC vault collateralized by other vaults in the Euler Base cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x882018411Bc4A020A879CEE183441fC9fa5D7f8B"),
    {
      name: "Euler Base cbBTC",
      description:
        "A conservative cbBTC vault collateralized by other vaults in the Euler Base cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x3f0d3Fd87A42BDaa3dfCC13ADA42eA922e638a7A"),
    {
      name: "Euler Base LBTC",
      description:
        "A conservative LBTC vault collateralized by other vaults in the Euler Base cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x5Fe2DE3E565a6a501a4Ec44AAB8664b1D674ac25"),
    {
      name: "Euler Base AERO",
      description:
        "A conservative AERO vault collateralized by other vaults in the Euler Base cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x556d518FDFDCC4027A3A1388699c5E11AC201D8b"),
    {
      name: "Euler Base USDS",
      description:
        "A conservative USDS vault collateralized by other vaults in the Euler Base cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x65cFEF3Efbc5586f0c05299343b8BeFb3fF5d81a"),
    {
      name: "Euler Base sUSDS",
      description:
        "A conservative sUSDS vault collateralized by other vaults in the Euler Base cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x841C92bfF53c81cDdb8ad557096B30C93fddb394"),
    {
      name: "Euler Base wsuperOETHb",
      description:
        "A conservative wsuperOETHb vault collateralized by other vaults in the Euler Base cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x72c8B07E5aD9F2DcC3cA2c05927c31ddCf2Ffe9A"),
    {
      name: "Euler Base USDT0",
      description:
        "A conservative USDT0 vault collateralized by other vaults in the Euler Base cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xC063C3b3625DF5F362F60f35B0bcd98e0fa650fb"),
    {
      name: "Apostro Resolv USDC vault",
      description:
        "Part of the Apostro Resolv cluster. This vault offers A-grade safety with the lowest insolvency risk. Risk manager: apostro.xyz.",
      entity: ["apostro"],
    },
  ],
  [
    getAddress("0x29Dbce367F5157B924Af5093617bb128477D7A5C"),
    {
      name: "Apostro Resolv USR vault",
      description:
        "Part of the Apostro Resolv cluster. This vault offers A-grade safety with the lowest insolvency risk. Risk manager: apostro.xyz.",
      entity: ["apostro"],
    },
  ],
  [
    getAddress("0x1E2F1e8A97E96a2FDD6A8Da427603Ed1c8b3847F"),
    {
      name: "Apostro Resolv cbBTC vault",
      description:
        "Part of the Apostro Resolv cluster. This vault offers A-grade safety with the lowest insolvency risk. Risk manager: apostro.xyz.",
      entity: ["apostro"],
    },
  ],
  [
    getAddress("0x3F131Ac9D408926a8B36C1e03ce105f44DCD26Af"),
    {
      name: "Apostro Resolv LBTC vault",
      description:
        "Part of the Apostro Resolv cluster. This vault offers A-grade safety with the lowest insolvency risk. Risk manager: apostro.xyz.",
      entity: ["apostro"],
    },
  ],
  [
    getAddress("0x5ce15fC058E762A6F9722fC6521A0c0F5eECD9BA"),
    {
      name: "Apostro Resolv PT-LBTC-29MAY2025 vault",
      description:
        "Part of the Apostro Resolv cluster. This vault offers A-grade safety with the lowest insolvency risk. Risk manager: apostro.xyz.",
      entity: ["apostro"],
    },
  ],
  [
    getAddress("0x34ABB4501419b1E5f836567C58300c861164101A"),
    {
      name: "Apostro Resolv cbETH vault",
      description:
        "Part of the Apostro Resolv cluster. This vault offers A-grade safety with the lowest insolvency risk. Risk manager: apostro.xyz.",
      entity: ["apostro"],
    },
  ],
  [
    getAddress("0xEdCc195Ca09c9FCC1DD30b152C0b82045Ff2F91f"),
    {
      name: "Apostro Resolv PT-USR-24APR2025 vault",
      description:
        "Part of the Apostro Resolv cluster. This vault offers A-grade safety with the lowest insolvency risk. Risk manager: apostro.xyz.",
      entity: ["apostro"],
    },
  ],
  [
    getAddress("0x596dBb33131fa2991cf5651cB57e4b15682C7F93"),
    {
      name: "Apostro Resolv PT-USR-25SEP2025 vault",
      description:
        "Part of the Apostro Resolv cluster. This vault offers A-grade safety with the lowest insolvency risk. Risk manager: apostro.xyz.",
      entity: ["apostro"],
    },
  ],
  [
    getAddress("0xaa40BD076d80F3bA18F7E09ddb1E9962c00C1047"),
    {
      name: "Re7 Labs USDC",
      description:
        "A USDC vault collateralized by other vaults in the Re7 Labs Cluster.",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x8300dE22B2c6c675C056fC75855423Ec7dC90F52"),
    {
      name: "Re7 Labs WETH",
      description:
        "A WETH vault collateralized by other vaults in the Re7 Labs Cluster.",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x5103f6C0D0aA0616C5DbAB52EcA82110322c9821"),
    {
      name: "Re7 Labs wstETH",
      description:
        "A wstETH vault collateralized by other vaults in the Re7 Labs Cluster.",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x12ebafd758c9532b02Dd57189c12A140D17D2b9E"),
    {
      name: "Re7 Labs ezETH",
      description:
        "A ezETH vault collateralized by other vaults in the Re7 Labs Cluster.",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x28CF85d1249Eb8a2988699Fd72E3B1CafAEfd17B"),
    {
      name: "Re7 Labs weETH",
      description:
        "A weETH vault collateralized by other vaults in the Re7 Labs Cluster.",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xCf033218B983d286fb3082b34c597bb408C55c0C"),
    {
      name: "Re7 Labs LBTC",
      description:
        "A LBTC vault collateralized by other vaults in the Re7 Labs Cluster.",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x9E77a118a136EEe9ec1be1D34a2C89FB0e953545"),
    {
      name: "Re7 Labs USR",
      description:
        "A USR vault collateralized by other vaults in the Re7 Labs Cluster.",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x4790BCbF34e2be50475364DACa01908eBa35e0ca"),
    {
      name: "Re7 Labs cbBTC",
      description:
        "A cbBTC vault collateralized by other vaults in the Re7 Labs Cluster.",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xbc02160f3AfdBb2fA77154b552504d7D01Bfdc2F"),
    {
      name: "Re7 Labs PT-LBTC-29MAY2025",
      description:
        "A PT-LBTC-29MAY2025 vault collateralized by other vaults in the Re7 Labs Cluster.",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xFab9aF50F7A1Cfe201CAE1c15fCFdDaE7705ccD3"),
    {
      name: "Frontier YO yoBTC",
      description:
        "A YO yoBTC vault collateralized by other vaults in the Frontier YO yoBTC market.",
      entity: ["euler-dao", "gauntlet"],
    },
  ],
  [
    getAddress("0x774C08F8e78C47046d325C0331788954C35DF10a"),
    {
      name: "Frontier YO WETH",
      description:
        "A YO WETH vault collateralized by other vaults in the Frontier YO yoETH market.",
      entity: ["euler-dao", "gauntlet"],
    },
  ],
  [
    getAddress("0xe72eA97aAF905c5f10040f78887cc8dE8eAec7E4"),
    {
      name: "Frontier YO cbBTC",
      description:
        "A YO cbBTC vault collateralized by other vaults in the Frontier YO yoBTC market.",
      entity: ["euler-dao", "gauntlet"],
    },
  ],
  [
    getAddress("0xdbDC9c3EdBD401109c83b333c16A0251806b3330"),
    {
      name: "Frontier YO yoETH",
      description:
        "A YO yoETH vault collateralized by other vaults in the Frontier YO yoETH market.",
      entity: ["euler-dao", "gauntlet"],
    },
  ],
  [
    getAddress("0x38Df63F1986B80578B7357BCda3D4f71F129AfFf"),
    {
      name: "Frontier YO PT-yoETH-26MAR2026",
      description:
        "A PT-yoETH-26MAR2026 collateral vault used to borrow yoETH in the Frontier YO yoETH market.",
      entity: ["euler-dao", "gauntlet"],
    },
  ],
  [
    getAddress("0x085178078796Da17B191f9081b5E2fCCc79A7eE7"),
    {
      name: "Frontier YO USDC",
      description:
        "A YO USDC vault collateralized by other vaults in the Frontier YO yoUSD market.",
      entity: ["euler-dao", "gauntlet"],
    },
  ],
  [
    getAddress("0x990d616ca6E7192625d1B7C41Fb67b5758DF7CF2"),
    {
      name: "Frontier YO yoUSD",
      description:
        "A YO yoUSD vault collateralized by other vaults in the Frontier YO yoUSD market.",
      entity: ["euler-dao", "gauntlet"],
    },
  ],
  [
    getAddress("0x24D633664Aea3F551B2Fa34fA66Dd1BA52a33933"),
    {
      name: "Frontier YO PT-yoUSD-26MAR2026",
      description:
        "A PT-yoUSD-26MAR2026 escrowed collateral vault used to borrow USDC and yoUSD in the Frontier YO yoUSD market.",
      entity: ["euler-dao", "gauntlet"],
    },
  ],
  [
    getAddress("0xF3BB6b0a9bEAF9240D7F4a91341d5Df6bF37cAea"),
    {
      name: "Alterscope LRT WETH",
      description:
        "Foundational vaults designed for maximium market stability.",
      entity: "alterscope",
    },
  ],
  [
    getAddress("0xf4480166d66CFb9c5E12C843A8F844F512989289"),
    {
      name: "Alterscope LRT yoETH",
      description:
        "Vaults designed for advanced liquid restaking strategies. Note: The price for yoETH is updated based on Yo Protocol’s own on-chain price updater.",
      entity: "alterscope",
    },
  ],
  [
    getAddress("0x611745c9107d0197f161556691c5129fD9B898D1"),
    {
      name: "Edge UltraYield USDC",
      description:
        "USDC vault collateralized by other vaults in the Edge UltraYield Cluster.",
      entity: "edge-capital",
    },
  ],
  [
    getAddress("0x614bD506051a8CCfCBc57C34aEdcf6CaffCd5d17"),
    {
      name: "Edge UltraYield WETH",
      description:
        "WETH vault collateralized by other vaults in the Edge UltraYield Cluster.",
      entity: "edge-capital",
    },
  ],
  [
    getAddress("0x1Fd3A242a549D595431442F898FDbb374F15B885"),
    {
      name: "Edge UltraYield wstETH",
      description:
        "wstETH vault collateralized by other vaults in the Edge UltraYield Cluster.",
      entity: "edge-capital",
    },
  ],
  [
    getAddress("0xD7c286712bd46aa8acBec4EA99d3018b32Edb190"),
    {
      name: "Edge UltraYield wrsETH",
      description:
        "wrsETH vault collateralized by other vaults in the Edge UltraYield Cluster.",
      entity: "edge-capital",
    },
  ],
  [
    getAddress("0x85114A78c512872Df273CA12f35FBE4Cf0749616"),
    {
      name: "Edge UltraYield weETH",
      description:
        "weETH vault collateralized by other vaults in the Edge UltraYield Cluster.",
      entity: "edge-capital",
    },
  ],
  [
    getAddress("0xBC46393223990D024fcb2b0Ff2f5A4cd52602ea2"),
    {
      name: "Edge UltraYield ezETH",
      description:
        "ezETH vault collateralized by other vaults in the Edge UltraYield Cluster.",
      entity: "edge-capital",
    },
  ],
  [
    getAddress("0x78d6A3BC9d41B7C6Fd52FF2E85a2dF6d1F4F9B3a"),
    {
      name: "Edge UltraYield cbBTC",
      description:
        "cbBTC vault collateralized by other vaults in the Edge UltraYield Cluster.",
      entity: "edge-capital",
    },
  ],
  [
    getAddress("0xA67A95971b8D010c16de4B33259D1c574d256121"),
    {
      name: "Edge UltraYield LBTC",
      description:
        "LBTC vault collateralized by other vaults in the Edge UltraYield Cluster.",
      entity: "edge-capital",
    },
  ],
  [
    getAddress("0x81744B5B5527852832F2dd3554C191d3B1342108"),
    {
      name: "AlphaGrowth reUSD Base Vault",
      description: "A supply-only reUSD vault managed by AlphaGrowth.",
      entity: "alphagrowth",
    },
  ],
  [
    getAddress("0x4C1aeda9B43EfcF1da1d1755b18802aAbe90f61E"),
    {
      name: "AlphaGrowth USDC Base Vault",
      description:
        "A borrowing-enabled USDC vault managed by AlphaGrowth, enabling leveraged strategies with reUSD collateral.",
      entity: "alphagrowth",
    },
  ],
])
